
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./adyen.cjs.production.min.js')
} else {
  module.exports = require('./adyen.cjs.development.js')
}
